




































import { Component, Vue } from 'vue-property-decorator';
import {getExamine, lookAtExamine} from '@/api/user/user';
import { goTop } from '@/global/utils';
import {DOMAIN} from '@/global/constants';
import moment from 'moment';
@Component
export default class MarkTags extends Vue {
    private columns: object[] = [
        {
            title: '任务名称',
            key: 'title',
            align: 'center',
            tooltip: true,
        },
        {
            title: '任务id',
            key: 'gid',
            align: 'center',
        },
        {
            title: '考核结果',
            slot: 'check_status',
            align: 'center',
        },
        {
            title: '参与时间',
            key: 'time',
            align: 'center',
        },
        {
            title: '查看详情',
            slot: 'cheack',
            align: 'center',
        },
    ];
    private loading: boolean = true;
    // 查询条件
    private searchVal: object = {
        gid: '',
        title: '',
    };
    private tableData: object[] = [];
    private total: number = 0;
    private tableParams: object = {
        page: 1,
        pagesize: 20,
    };
    private created() {
        this.getListData({...this.tableParams});
        goTop();
    }
    // 获取列表
    private async getListData(option) {
       try {
          this.loading = true;
          const res = await getExamine(option);
          (res as any).rows.map((item, index) => {
            item.time = moment(item.time * 1000).format('YYYY-MM-DD HH:mm:ss');
          });
          this.tableData = (res as any).rows;
          this.total = (res as any).total;
       } catch (err) {
           console.log(err);
       }
       this.loading = false;
    }
    // 查看 考核题
    private async handleCheck(id: number, gId: number) {
       try {
           const res = await lookAtExamine({gid: gId});
           const result = res as any;
           let from = 'markPage';
           if (result.from.indexOf('sketch') > -1) {
             from = result.from.indexOf('-') > -1 ? result.from.split('-')[1] : 'markPage';
           }
           window.open(`${DOMAIN}/tools/${from}.html?type=222&id=${id}`);
       } catch (err) {
           console.log(err);
       }
    }
    // 分页切换
    private async changePage(num: number) {
        (this.tableParams as any).page = num;
        this.getListData({ ...this.tableParams});
        goTop();
    }
    // 查询
    private handleSearch() {
        const searchVal = this.searchVal as any;
        if (searchVal.gid || searchVal.title) {
            const option = Object.assign({}, this.searchVal, {
                page: 1,
                pagesize: 20,
            });
            this.getListData({...option});
        } else {
            this.tableParams = {
                page: 1,
                pagesize: 20,
            };
            this.getListData({...this.tableParams});
        }
    }
}
